import { render, staticRenderFns } from "./nutritionMainpagePortionSizesUpload.vue?vue&type=template&id=3a5d6756&scoped=true"
import script from "./nutritionMainpagePortionSizesUpload.vue?vue&type=script&lang=js"
export * from "./nutritionMainpagePortionSizesUpload.vue?vue&type=script&lang=js"
import style0 from "./nutritionMainpagePortionSizesUpload.vue?vue&type=style&index=0&id=3a5d6756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d6756",
  null
  
)

export default component.exports